export default function menuBurger({main, on, elm}) {
	main(() => {
		on('click', '.btn--2lvl-opener', open2lvl);
		on('click', '.btn--2lvl-back', close2lvl);
		on('click', '.menu__backdrop', closeAll);
	});

	const open2lvl = function(e) {
		const menuItem = e.target.closest('.menu__item--with-2lvl');
		menuItem.classList.add('menu__item--open');

		const brandsList = menuItem.querySelector('.brands');
		const height = brandsList.offsetHeight;
		brandsList.style.height = `${height / 2 + 100}px`;
	};

	const close2lvl = function(e) {
		const menuItem = e.target.closest('.menu__item--with-2lvl');
		menuItem.classList.remove('menu__item--open');
	};

	const closeAll = function() {
		elm.classList.remove('menu--open');
		elm.querySelector('search-box')?.resetSearch?.();

		const parentItems = [...elm.querySelectorAll('.menu__item--with-2lvl')];
		parentItems.forEach(item => item.classList.remove('menu__item--open'));
	};
}

export const model = {};
